import {EventBus} from "OK/EventBus";

export const VideoPlayerEventBusesPrefix = 'videoPlayer';

/**
 * @description Оповещаем о событиях из видео-плеера
 * блок с рекомендациями в видео леере
 * (рендерится справа вместе с рекомендациями и/или с видео из канала).
 */
const create = EventBus.factory(VideoPlayerEventBusesPrefix);

export interface IEpisodeChangedData {
    movieId: string;
    time: string;
}

export interface IEpisodeClickedData {
    movieId: string;
}

/**
 * Поменялся просматриваемый эпизод
 */
export const EPISODE_CHANGED = create<IEpisodeChangedData>('episodeChanged');
/**
 * Запрос на открытие меню с эпизодами для выбора
 */
export const EPISODE_CLICKED = create<IEpisodeClickedData>('episodeClicked');